import type { Restaurant } from "@/API";
import type { State } from "@/types/common";
import { create } from "zustand";
import { generateClient } from "aws-amplify/api";
import { getUserRestaurants as getUserRestaurantsQuery } from "@/graphql/queries";

const client = generateClient();

export const userRestaurantsState = create<State<Restaurant[]>>(() => ({
  data: null,
  isLoading: false,
  error: null,
  isFetching: false,
}));

export const getUserRestaurantsIsloading = () =>
  userRestaurantsState.setState(() => ({
    isLoading: true,
    isFetching: false,
    data: null,
    error: null,
  }));
export const getUserRestaurantsIsError = (error: Error) =>
  userRestaurantsState.setState(() => ({
    error: error,
    data: null,
    isLoading: false,
    isFetching: false,
  }));
export const getUserRestaurantsIsSuccess = (queryResult: Restaurant[]) =>
  userRestaurantsState.setState(() => ({
    data: queryResult,
    isLoading: false,
    error: null,
    isFetching: false,
  }));

export const getUserRestaurants = async () => {
  getUserRestaurantsIsloading();

  try {
    const { data } = await client.graphql({
      query: getUserRestaurantsQuery,
    });

    getUserRestaurantsIsSuccess(data.getUserRestaurants as Restaurant[]);
  } catch (e) {
    const errorMessage =
      e instanceof Error ? e.message : "failed to query getUserRestaurants";
    getUserRestaurantsIsError(Error(errorMessage));
  }
};

export const removeUserRestaurantInRestaurants = async (
  restaurantId: string,
) => {
  const { data } = userRestaurantsState.getState();
  if (data) {
    const copyData = [...data];
    const restaurantToRemove = copyData.findIndex(
      ({ id }) => id === restaurantId,
    );

    if (restaurantToRemove !== -1) {
      copyData.splice(restaurantToRemove, 1);
      getUserRestaurantsIsSuccess(copyData);
    }
  }
};
